import { render } from "./PersonalPaymentDetails.vue?vue&type=template&id=2b8580c7&scoped=true&lang=pug"
import script from "./PersonalPaymentDetails.vue?vue&type=script&lang=ts"
export * from "./PersonalPaymentDetails.vue?vue&type=script&lang=ts"

import "./PersonalPaymentDetails.vue?vue&type=style&index=0&id=2b8580c7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2b8580c7"

export default script